import { ChangeDetectorRef, Component, ElementRef, NgZone, OnInit, Renderer2, ViewChild, } from '@angular/core';
import { NgxCaptureService } from 'ngx-capture';
import { DataSharingService } from '../services/data-sharing.service';
import { ActivatedRoute, Router } from '@angular/router';
import { WebSocketService } from '../services/web-socket.service';
import { DatePipe } from '@angular/common';


declare var startRecording;
declare var leaveChannel;
declare var muteAudio;
declare var unmuteAudio;
declare var stopLocalStream;
declare var SwitchDevice;
declare var onDownload;
declare var muteUnmuteAudio;
declare var setVideoBackgroundImageFileName;
declare var sendLogDataToServer;
// declare var $: any;
declare var setLogIntoDB;
declare var setOptimizationMode;
export interface postData {
  "caseid": string;
  "value": string;
  "valuetype": string;
  "imagebase64": string;
  "dbIndex"?: string | number
}




@Component({
  selector: 'app-video-calling',
  templateUrl: './video-calling.component.html',
  styleUrls: ['./video-calling.component.scss']
})
export class VideoCallingComponent implements OnInit {

  mobileNo: string = "";
  infoText = "";
  @ViewChild('remoteVideo', { static: true }) remoteVideo: any;
  @ViewChild('nav') slider: any;
  @ViewChild('navForImgDele') navForImgDele: any;


  // allCapturedImages = [];

  appId: string = "";
  channelName: string = "";
  uid: string = "";
  aquiredResourceObj = {};
  token: string = "";

  videoRecordingDetailsObj = {};
  capturedImages = [];
  capturedImagesForDeletion = [];
  backupForCapturedImagesForDeletion = {};
  isSMSSend: boolean = false;
  acquiredResourceID = undefined;
  sid = undefined;
  caseID = undefined;
  applicantName = "";
  client = "";
  clientFullName: string = "";// this property will store full name of client and will pass to the 
  activity: string = "";
  email = "";

  isRecordingStarted: boolean = false;
  showSuccesMsg: boolean = false;
  showConfirmationModal: boolean = false;
  showLoadingModal: boolean = false;
  showConfirmationModalForDeleteImage: boolean = false;
  deleteImageEvent;

  loadingTitleModalMsg: string = "";
  loadingsubTitleModalMsg: string = "";
  loadingBodyModalMsg: string = "";
  emailMsg: string = "";
  smsStatus: string = "";

  currentSliderImgIndx = 5;

  showErrorMsg: boolean = false;
  errorMsg: string = "";
  isCameraSwitch: boolean = false;
  public address?: string = '';

  public commonMessagesModal = {
    "show": false,
    "title": "",
    "message": "",
    "okBtnText": "",
    "cancelBtnText": ""
  };

  postDataArr: postData[] = [];
  agoraVideoRecordingObj = {};// this object is use to store the agora stopped video call response object. and read at the time of saving to DB.
  userId;
  astuteUserUID

  timeInterval: any;
  processTime: any = 0;
  pauseProcessTime: any = 0;
  timeIntervalStr = "00:00";
  startTime;
  endTime;
  confirmCloseWithNoImages: boolean = false;
  warningMsg: string = "";
  videoPath = "";
  clientActivity = "";
  monthYear = "";
  clientId;
  private clientIdReserved = 0;
  activityId;
  cliActId;
  videoFilePath: string = "";
  meetingStarted = false;

  isMute: boolean = false;
  scaleFactor = 2;

  toastMsg = {
    "show": false,
    "isSuccess": false,
    "msg": "Screenshot has benn taken"
  };

  terminatedByRemoteUser = false;
  isLoader: boolean = false;
  sendSMSandLinkObj = {};
  msgId = '';
  isVideoCallStarted:boolean = false;
  constructor(private datePipe: DatePipe, private capture: NgxCaptureService, public dataSharingSrvc: DataSharingService,
    private router: Router, private activatedRoute: ActivatedRoute, private _elementRef: ElementRef,
    private renderer: Renderer2, private changeDetectorRef: ChangeDetectorRef,
    public webSocketSrvc: WebSocketService) { }

  // slideImage(slideTo: string) {

  //   console.log("------------------------------_Before condition-----------------");
  //   console.log("currentSliderImgIndx : ", this.currentSliderImgIndx);

  //   if (slideTo == "prev") {
  //     this.currentSliderImgIndx -= 4;
  //     if (this.currentSliderImgIndx <= 0 || this.currentSliderImgIndx <= 1) {
  //       this.currentSliderImgIndx = 1;
  //     }
  //   }
  //   else {
  //     this.currentSliderImgIndx += 4;
  //     if (this.currentSliderImgIndx >= 11 || this.currentSliderImgIndx >= 12) {
  //       this.currentSliderImgIndx = 11;
  //     }
  //   }

  //   // if (slideTo == "prev" && (this.currentSliderImgIndx == 12 || this.currentSliderImgIndx > 4)) {
  //   //   this.currentSliderImgIndx -= 5;
  //   // }

  //   // // if (this.currentSliderImgIndx == 12 || slideTo == "prev") {
  //   // //   this.currentSliderImgIndx =11;
  //   // // }

  //   // this.currentSliderImgIndx = (slideTo == "prev" ? (this.currentSliderImgIndx - 1) : (this.currentSliderImgIndx + 1));
  //   // if (this.currentSliderImgIndx <= 0 && slideTo == "prev") {
  //   //   this.currentSliderImgIndx = 4;
  //   // }
  //   // if (this.currentSliderImgIndx <= 0 && slideTo != "prev") {
  //   //   this.currentSliderImgIndx = 5;
  //   // }
  //   let elem = document.getElementById(("img" + this.currentSliderImgIndx));

  //   console.log("After currentSliderImgIndx : ", this.currentSliderImgIndx);
  //   console.log("------------------------------END-----------------");

  //   if (elem) {
  //     elem.scrollIntoView({ "behavior": "smooth", "block": "nearest", "inline": "nearest" });
  //   }

  // }




  ngOnInit(): void {

    console.log("In video calling Component.............................");
    
    //this.showToastMsg(true,'Screenshot captured')
    this.activatedRoute.queryParams.subscribe(
      resp => {
        if (resp['caseId']) {
          this.caseID = (resp['caseId'] as string).trim();
          this.applicantName = (resp['applicantName'] as string).toString().trim();
          this.mobileNo = (resp['mobileNo'] as string).toString().trim();
          this.client = (resp['client'] as string).toString().trim();
          this.clientFullName = (resp['client'] as string).toString().trim();
          this.clientId = (resp['clientId'] as string).toString().trim();
          this.clientIdReserved = this.clientId;
          this.activityId = (resp['activityId'] as string).toString().trim();
          this.client = this.client.length > 20 ? (this.client.substr(0, 17) + "...") : this.client;
          this.activity = (resp['activity'] as string).toString().trim();
          this.activity = this.activity.length > 20 ? (this.activity.substr(0, 17) + "...") : this.activity;

        }
        else {
          this.caseID = "12345"
          this.applicantName = "Anand"
          this.mobileNo = "7769837705";
          this.client = "BOB";
          this.clientFullName = "BANK OF BARODA";
          // this.client = "This is jagdish suryawanshi";
          // this.activity = "This is sample activity";
          this.activity = "Test";
          this.clientId = "1034"
          this.activityId= "222"
        }
      }
    );

    // this.videoRecordingDetailsObj = {
    //   "token": "006954fe296e16d4de1975f9bb6cd25b061IADslYfOCUwrfi8lqeV/izMn922vlYDk6/t0QrVW4oYwc7w0zE8AAAAAIgC/gPgDYQEeYQQAAQBhIB1hAgBhIB1hAwBhIB1hBABhIB1h",
    //   "channel": "case1629269985392",
    //   "uid": "",
    //   "appId": "954fe296e16d4de1975f9bb6cd25b061"
    // };
    // console.log("%c SMS sent successfully!", " background: #222; color: #bada55;font-size:25px;");

    // startRecording(this.videoRecordingDetailsObj['appId'], this.videoRecordingDetailsObj['token'], this.videoRecordingDetailsObj['channel']);
    let dd = this.datePipe.transform(new Date(), "dd-MMM-yyyy");
    let dateSplit = dd.split("-");
    this.clientActivity = this.client + "_" + this.activity;
    this.monthYear = dateSplit[1] + dateSplit[2];
    this.clientId = "CLI" + this.clientId?.toString().padStart(4, '0');
    this.activityId = "ACT" + this.activityId?.toString().padStart(4, '0');
    this.cliActId = this.clientId + this.activityId;
    this.videoPath = this.clientId + this.activityId + "/" + this.monthYear;
    // this.generateRandomNo();
    console.log("videoPath: ", this.cliActId);

    this.webSocketSrvc.LocationUser$.subscribe((loc: any) => {
      // console.error(loc,'loc');
      if (loc.latitude && loc.longitude && this.meetingStarted) {
        this.isRecordingStarted = true
      }

    });
    // this.getAddressFromLatLog('18.5991168','73.7837056');
  }
  generateRandomNo() {
    let minm = 1000000000;
    let maxm = 2100000000;
    let value = Math.floor(Math.random() * (maxm - minm * 1)) + minm;
    this.userId = value.toString();//"1111001111";//value.toString();
  }

  carousalImgSelection(event) {
    // console.log("nav : ", this.slider);
    // console.log("carousal event  : ", event);
  }


  closeErrorModal() {
    document.getElementById("errormsgModal").style.display = "none";
    this.isRecordingStarted = false;
    this.requestAgoraToStopRecordingsToAllowFilesTbeWrittenOnS3();
    this.resetProps();


    // this.router.navigateByUrl("accept-invitation/" + this.dataSharingSrvc["autoId"] + "/" + this.dataSharingSrvc["token"]);
  }


  generateRandomText = () => {
    this.infoText = (Math.random() + 1).toString(36).substring(2);
  }

  // captureImage = () => {
  //   this.generateRandomText();
  //   setTimeout(() => {
  //     this.capture.getImage(this.remoteVideo.nativeElement, true).subscribe(img => {
  //       debugger;
  //       this.allCapturedImages.push(img);
  //     })
  //   }, 100)
  // }

  captureVideImage = () => {
    let allVideoElements = this._elementRef.nativeElement.querySelectorAll('video');
    let w: number, h: number, ratio: number;

    for (let index = 0; index < allVideoElements.length; index++) {
      const videoEle = allVideoElements[index];
      if (videoEle['id'] == "videoundefined") {
        continue;
      }
      let videoBoundedRectangle = videoEle.getBoundingClientRect();

      ratio = videoBoundedRectangle.width / videoBoundedRectangle.height;

      let height = videoBoundedRectangle.height * this.scaleFactor;
      let width = videoBoundedRectangle.width * this.scaleFactor;

      w = videoBoundedRectangle.width - 100;
      h = w / ratio;

      // console.log('ratio', ratio);
      // console.log('h', h);
      // console.log('w', w, w + 100);

      const canvasdraw = this.renderer.createElement('canvas');
      const context = canvasdraw.getContext('2d');

      canvasdraw.width = width;//w;
      canvasdraw.height = height;//h;

      // context.fillRect(0, 0, w, h);
      context.fillRect(0, 0, width, height);

      //context.drawImage(videoBoundedRectangle, 0, 0, w, h);
      context.drawImage(videoEle, 0, 0, width, height);

      const dataURI = canvasdraw.toDataURL('image/jpg');
      // console.log(dataURI);

      if (dataURI && dataURI?.length && dataURI?.length > 6) {
        this.capturedImages.push({ "image": dataURI, "thumbImage": dataURI, "alt": "", retryUploadImage: false });
        this.capturedImagesForDeletion.push({ "image": "", "thumbImage": "", "alt": "", retryUploadImage: false });
        const capturedImagesInd = (this.capturedImages.length - 1);
        const capturedImagesForDeletionInd = (this.capturedImagesForDeletion.length - 1);
        this.capturedImages[capturedImagesInd]['arrayIndex'] = capturedImagesInd;
        this.capturedImages[capturedImagesInd]['dbIndex'] = -1;


        this.capturedImagesForDeletion[capturedImagesForDeletionInd]['arrayIndex'] = capturedImagesForDeletionInd;
        this.capturedImagesForDeletion[capturedImagesForDeletionInd]['dbIndex'] = -1;

        this.saveVCallDetailsImageAndVideoIntoDatabase(capturedImagesInd);


      } else {
        // this.showToastMsg(false, 'screenshot error')
      }
    }
  }

  scaleImaget(source, scaleFactor) {
    var c = document.createElement('canvas');
    var ctx = c.getContext('2d');
    var w = source.width * scaleFactor;
    var h = source.height * scaleFactor;
    c.width = w;
    c.height = h;
    ctx.drawImage(source, 0, 0, w, h);
    return (c);
  }

  deleteCarousalImage(evt) {
    this.deleteImageEvent = evt;
    this.showConfirmationModalForDeleteImage = true;
  }
  confirmDeleteImage() {
    this.backupForCapturedImagesForDeletion[this.deleteImageEvent + 'capturedImages'] = this.capturedImages[this.deleteImageEvent];
    this.backupForCapturedImagesForDeletion[this.deleteImageEvent + 'capturedImagesForDeletion'] = this.capturedImagesForDeletion[this.deleteImageEvent];
    this.deleteCaptureVideImageFomServer(this.deleteImageEvent);
  }

  arrowClick(evt) {
    if (evt['action'] == "next") {
      this.navForImgDele.next();
    }
    else {
      this.navForImgDele.prev();
    }
  }

  showCommonModal(title, message, okBtnText, cancelBtnText = "") {

    this.hideLoader('loader-div')
    this.hideLoader('loader-div1')

    this.commonMessagesModal.show = true;
    this.commonMessagesModal.title = title;
    this.commonMessagesModal.message = message;
    this.commonMessagesModal.okBtnText = okBtnText;
    this.commonMessagesModal.cancelBtnText = cancelBtnText;
  }

  resetProps() {
    this.showConfirmationModal = false;

    this.webSocketSrvc['latitude'] = "";
    this.webSocketSrvc['longitude'] = "";
    this.email = "";
    this.mobileNo = "";
    this.capturedImages = [];
  }

  closeMeeting(msg = "Screenshot is not taken, are you sure to close the call?", fromjs = false) {
    this.warningMsg = "";
    this.hideLoader('loader-div1');
    this.hideLoader();
    this.terminatedByRemoteUser = fromjs;
    if (this.capturedImages.length == 0) {
      const txt = ` Screenshot is not taken, are you sure to close the call?`;
      this.warningMsg = fromjs ? msg + ` Screenshot is not taken, <br> Do you want to save call details?` : txt;
    }
    else {
      this.warningMsg = fromjs ? msg + `<br> Do you want to save call details?` : "Close video call?";
    }
    this.showConfirmationModal = true;
  }

  confirmCloseButton() {
    // debugger;
    this.showConfirmationModal = false;
    if (this.webSocketSrvc['latitude'] != "") {

    }
    this.endTime = new Date();
    clearInterval(this.timeInterval);
    this.isLoader = true;
    // this.showLoader();
    this.requestAgoraToStopRecordingsToAllowFilesTbeWrittenOnS3();


    // this.showCommonModal("Close Video Call", "Video call has been terminated", "Ok");
    //this.showCommonModal("Close Video Call", "Thanks for your time, this call is now closed. We suggest to close this window.", "Ok");
    // this.saveDetailsIntoDatabase();
    // this.resetProps();
    leaveChannel();
  }


  getVideoFileName() {
    try {
      let fileName: string = "";
      this.videoFilePath = "";
      let fileList: any[] = [];
      fileList = this.videoRecordingDetailsObj['serverResponse']['fileList'];

      for (let index = 0; index < fileList.length; index++) {
        const element = fileList[index];
        if ((element['fileName'] as string).includes(".mp4")) {
          this.videoFilePath = (element['fileName'] as string);
          fileName = (element['fileName'] as string).replace("" + this.videoPath + "/", "");
          break;
        }
      }

      return fileName;
    } catch (error) {

    }

  }
  leavechannel() {
    this.showConfirmationModal = false;
    leaveChannel();
    this.resetProps();
    this.meetingStarted = false;
    location.reload();
  }

  downloadVideoFile() {

    let fileName: string = this.getVideoFileName();
    let obj = {
      "filename": fileName,
      "fileloc": this.videoPath
    }

    this.dataSharingSrvc.getMethodForAWS("downloadvideofile?criteria=" + JSON.stringify(obj), {})
      .subscribe(
        blob => {

          const a = document.createElement('a');
          const objectUrl = URL.createObjectURL(blob);
          a.href = objectUrl;
          a.download = 'video_call_' + this.caseID + '.mp4';
          a.click();
        },
        err => {
          console.error();
        }
      )



  }

  saveDetailsIntoDatabase() {
    this.saveVCallDetailsImageAndVideoIntoDatabase();
    return;
    sendLogDataToServer({ logType: "start=>save Into Database", reqName: "save Details Into Database", dateTime: new Date().toISOString() });

    this.postDataArr = [];
    this.getVideoFileName();

    this.postDataArr.push({
      "caseid": this.caseID,
      "valuetype": "videourl",
      "value": this.videoFilePath,//this.getVideoFileName(),
      "imagebase64": ""
    });

    this.postDataArr.push({
      "caseid": this.caseID,
      "valuetype": "lat",
      "value": this.webSocketSrvc['latitude'],
      "imagebase64": ""
    });

    this.postDataArr.push({
      "caseid": this.caseID,
      "valuetype": "lng",
      "value": this.webSocketSrvc['longitude'],
      "imagebase64": ""
    });
    this.postDataArr.push({
      "caseid": this.caseID,
      "valuetype": "callstarttime",
      "value": this.startTime,
      "imagebase64": ""
    });
    this.postDataArr.push({
      "caseid": this.caseID,
      "valuetype": "callendtime",
      "value": this.endTime,
      "imagebase64": ""
    });
    this.postDataArr.push({
      "caseid": this.caseID,
      "valuetype": "callduration",
      "value": this.timeIntervalStr,
      "imagebase64": ""
    });

    for (let index = 0; index < this.capturedImages.length; index++) {

      const element = this.capturedImages[index];

      this.postDataArr.push({
        "caseid": this.caseID,
        "valuetype": "img",
        "value": "",
        "imagebase64": element['image']
      });

    }


    let body = {
      "caseid": this.caseID,
      "vdetails": this.postDataArr,
      "autoId": this.dataSharingSrvc["autoId"],
      "callStatus": "C"
    };
    this.showLoader();
    this.dataSharingSrvc.postMethod("saveVCallDetails", body)
      .subscribe(succ => {
        console.warn("saveVCallDetails success", succ);

        if (succ['errorCode'] == 0) {
          this.confirmCloseWithNoImages = false;
          console.warn("saveVCallDetails success");
          this.isRecordingStarted = false;
          this.isSMSSend = false;
          this.showLoadingModal = false;
          this.showCommonModal("Close Video Call", "Call details are saved. Please close window.", "Ok");
          this.resetProps();
          // leaveChannel();
          // stopLocalStream();
          this.meetingStarted = false;
          const win: any = window;
          sendLogDataToServer({ logType: "end=>save Into Database", reqName: "save Details Into Database", dateTime: new Date().toISOString() });

        }
        else {
          console.error(succ);
          this.showCommonModal("Close Video Call", "Error while saving call details.", "Error");
          this.saveDetailsIntoDatabase();
        }
        this.isLoader = false;
        this.hideLoader();
      }, err => { this.hideLoader(); this.saveDetailsIntoDatabase() });
  }

  gotoPage() {
    this.router.navigateByUrl("invite/1234");
  }

  removeImage(img, indx) {
  }
  checkEmailPattern(email) {
    const regularExpression = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regularExpression.test(String(email).toLowerCase())
  }

  checkMobileNoPattern(mobile) {
    const mobNumberPattern = /^((\\+91-?)|0)?[0-9]{10}$/;
    return mobNumberPattern.test(String(mobile).toLowerCase())
  }

  generate3DigitRandomNumberTobeAppendedToAgoraUid() {
    return Math.floor(Math.random() * (999 - 100 + 1) + 100);
  }
  sendSMS() {

    try {
      let emailPattern = this.checkEmailPattern(this.email);
      let mobilePattern = this.checkMobileNoPattern(this.mobileNo);
      if (this.email != "") {
        if (!emailPattern) {
          this.isSMSSend = true;
          this.showErrorMsg = true;
          this.errorMsg = "Please enter valid email id!";
          return;
        }
      }
      else if (this.mobileNo != "") {
        if (!mobilePattern) {
          this.showErrorMsg = true;
          this.errorMsg = "Please enter valid mobile number!";
          this.isSMSSend = true;
          return;
        }
      }
      else {
        this.showErrorMsg = true;
        this.errorMsg = "Please enter either email id or mobile number!";
        return;
      }


      this.showSuccesMsg = true;
      this.emailMsg = "Sending video link, please wait...";
      this.generateRandomNo();
      // if (this.mobileNo.toString().length < 10) {
      //   alert("Invalid mobile number");
      //   return;
      // }
      // this.caseID = "case" + (new Date().getTime());
      // const astuteUserUID = +(this.mobileNo.toString().substring(0, 6)+'101010');
      const astuteUserUID = +('444' + this.generate3DigitRandomNumberTobeAppendedToAgoraUid().toString());
      this.astuteUserUID = astuteUserUID;
      const mobileNo = (this.mobileNo || 456 + this.generate3DigitRandomNumberTobeAppendedToAgoraUid()) + '';
      const body = {
        // "appId": "954fe296e16d4de1975f9bb6cd25b061",
        // "channel": "testvideo",
        // "token": "006954fe296e16d4de1975f9bb6cd25b061IAAnNWyCwb97agUioOvZ4VhSqi9VNsp95cJX0PIY9YDbQviAmyQAAAAAEACe0CRJ1k8SYQEAAQDVTxJh",
        "uid": this.mobileNo,
        "clientName": this.clientFullName,
        "applicantName": this.applicantName,
        "astuteUserUID": astuteUserUID,//(new Date().getTime()),
        "caseId": this.caseID,
        "email": this.email,
        "clientId": this.clientIdReserved
      };

      // this.isSMSSend = false;
      this.isSMSSend = true;

      this.dataSharingSrvc.postMethod("sendSMSandLink", body)
        .subscribe(
          async (succ) => {
            // alert("Video link sent successfully");
            // console.log("%c SMS sent successfully!", " background: #222; color: #bada55;font-size:25px;");
            if (succ['errorCode'] == 0) {
              this.sendSMSandLinkObj = succ
              this.msgId = succ['data']['msgid']
              this.checkSmsStatus()
            }
            else {
              console.error(succ);
            }
          },
          err => {
            console.error(err);
          }
        );

    } catch (err) {
      console.error(err);
    }
  }
 
  checkSmsStatus = async () => {
    try {
      const body = { msgId: this.msgId };
      this.dataSharingSrvc.postMethod("getSmsStatus", body).subscribe(
          async (succ) => {
           if (succ['errorCode'] == 0) {
            this.emailMsg='SMS Sent, SMS Status is '+succ['data'];
              if (`${succ['data']}`.includes('DELIVRD')) {
                this.startVideoCallAPI()
              }if(`${succ['data']}`.includes('REJECTD')){
                this.emailMsg='SMS Sent, SMS Status is <span class="rejected">Rejected</span>';
              }if(`${succ['data']}`.includes('UNDELIV')){
                this.emailMsg='SMS Sent, SMS Status is <span class="rejected">Undelivered</span>';
                setTimeout(this.checkSmsStatus,1000)
              } else {
                setTimeout(this.checkSmsStatus,1000)
              }
            }
            else {
              console.error(succ);
            }
          },
          err => {
            console.error(err);
          }
        );
    } catch (error) {

    }
  }
  async startVideoCallAPI() {
    if(this.isVideoCallStarted)return;
    this.isVideoCallStarted = true;
    const succ = this.sendSMSandLinkObj;
    // alert("Video link sent successfully");
    // console.log("%c SMS sent successfully!", " background: #222; color: #bada55;font-size:25px;");

    this.isSMSSend = true;
    // this.isRecordingStarted = true;
    this.emailMsg = "The video link has been sent successfully.";
    this.videoRecordingDetailsObj = {};
    this.videoRecordingDetailsObj = succ['data'];
    this.dataSharingSrvc["autoId"] = this.videoRecordingDetailsObj["id"];
    // this.showLoader('loader-div1');
    this.showLoadingModalDialog('Waiting for responder to join the call.', 'Video will appear once responder joins.','Message delivered')
    if (this.videoRecordingDetailsObj['isvcallogstartflag'] == 'Y') {
      setLogIntoDB(true);
    } else {
      setLogIntoDB(false);
    }
    setTimeout(() => {
      this.showSuccesMsg = false;
    }, 6000);
    await startRecording(succ['data']['appId'], succ['data'].token, succ['data'].channel, succ['data']['astuteUserUID'] || this.astuteUserUID, this.caseID);
    // succ['data']['bgimg'] = 'https://api.nasa.gov/assets/img/general/apod.jpg'
    if (succ['data']['bgimg']) {
      setVideoBackgroundImageFileName(succ['data']['bgimg'])
    }
    this.meetingStarted = true;
  }

  updateTimer = () => {



    this.processTime += 1;

    // let hr = (Math.floor(this.processTime / 3600)).toString();
    // let minutes = (Math.floor((this.processTime - (+hr * 3600)) / 60)).toString();

    let minutes = (Math.floor((this.processTime / 60))).toString().padStart(2, '0');
    let seconds = (this.processTime - (+minutes) * 60).toString().padStart(2, '0');

    // if (minutes.toString().length == 1) minutes = "0" + minutes;
    // if (seconds.toString().length == 1) seconds = "0" + seconds;

    this.timeIntervalStr = minutes + ":" + seconds;
    this.isRecordingStarted = true;
    // console.log(this.processTime, 'minutes', minutes, 'seconds', seconds);
    // console.log(this.timeIntervalStr);
    this.changeDetectorRef.detectChanges();
  }

  /*****Calling from the HTMl button */

  async startVideoRecording() {

    try {
      // return;
      const agoraAquireResourceId = await this.invokeAquireAPIandGetResourceId();
      console.warn('agoraAquireResourceId', agoraAquireResourceId);

      this.acquiredResourceID = agoraAquireResourceId['resourceId'];
      this.requestAgoraToStartRecordingandStoreFileToAwsS3(agoraAquireResourceId['resourceId']);
      this.startTime = new Date();
      this.timeInterval = setInterval(this.updateTimer, 1000);
      console.warn("Recording Started");
      // this.hideLoader('loader-div1');
      this.showLoadingModal = false;
    } catch (err) {
      console.error("start recording error : ", err);
    }
  }

  requestAgoraToStartRecordingandStoreFileToAwsS3(agoraAquireResId: any) {

    const body = {
      "userId": this.userId,
      "caseId": this.caseID
    };

    //  this.isSMSSend = false;

    // this.saveVCallDetailsImageAndVideoIntoDatabase(-1,true);
    this.sendOnlyLocationWhenItsAvailable()
    this.dataSharingSrvc.postMethod("acquireNewToken", body).subscribe(succ => {
      if (succ['errorCode'] == 0) {
        let uidNo = (this.mobileNo as string).toString().substr(0, 6);
        this.astuteUserUID
        // console.warn(this.astuteUserUID);

        const newToken = succ['data'];
        //console.log("New Token : ", succ, succ['data']);
        const reqBody = {
          "uid": this.userId,//"1111001111",//this.videoRecordingDetailsObj['uid'],
          "cname": this.videoRecordingDetailsObj['channel'],
          "clientRequest": {
            "token": newToken,
            "recordingConfig": {
              "getVideoFrame": 5,
              "channelType": 0,
              "streamTypes": 2,
              "subscribeVideoUids": ["#allstream#"],
              "subscribeAudioUids": ["#allstream#"],
              "transcodingConfig": {
                "width": 360,
                "height": 640,
                "fps": 15,
                "bitrate": 500,
                "mixedVideoLayout": 3,
                "layoutConfig": [{
                  "uid": uidNo,
                  "x_axis": 0.0,
                  "y_axis": 0.0,
                  "width": 1.0,
                  "height": 1.0,
                  "alpha": 1.0,
                  "render_mode": 1
                },
                {
                  "uid": `${this.astuteUserUID}`,
                  "x_axis": 0.75,
                  "y_axis": 0.65,
                  "width": 0.25,
                  "height": 0.25,
                  "alpha": 1.0,
                  "render_mode": 1
                }]
              }
            },
            "recordingFileConfig": {
              "avFileType": ["hls", "mp4"]
            },
            // "snapshotConfig": {
            //   "captureInterval": 5,
            //   "fileType": [
            //     "jpg"
            //   ]
            // },
            // "storageConfig": {//AWS S3 new account storage object
            //   "accessKey": "AKIA44BPX7ZTDLCQ4MXE",//"AKIAYNF3ZTRBPFO75H4V",//AKIAYMYI63WUL56K6RPK, //"atom361dev",
            //   "bucket": "astute-s3bucket",//"viotal-demos3",
            //   "region": 14,
            //   "secretKey": "Gyw3pZJoEyOeA2S/R6hR24OsdXM8y5am+tkMXvUE",//"CuLGIFMYe35d7Z8betuvEeJoNy73J/0DshInrvsc",//fVntZIxLzWZJeWszmbX8PTXEWZk/H07+673ZzEOh, //"tzN2CeTjfZ/BTe6kyxCNa35Y57H9HX2nE65w1a7CdJRLjOP6KnRQGAfkObBknytE4z+PBI8QXNHbC9tjb36BNg==",
            //   "vendor": 1,
            //   "fileNamePrefix": ["agoravideo", this.cliActId, this.monthYear]
            // }
            "storageConfig": {// Astute Azure Storage object
              "accessKey": "atom361dev",//"tzN2CeTjfZ/BTe6kyxCNa35Y57H9HX2nE65w1a7CdJRLjOP6KnRQGAfkObBknytE4z+PBI8QXNHbC9tjb36BNg==",
              "region": 14,
              "bucket": "agoravideo",
              "secretKey": "tzN2CeTjfZ/BTe6kyxCNa35Y57H9HX2nE65w1a7CdJRLjOP6KnRQGAfkObBknytE4z+PBI8QXNHbC9tjb36BNg==",
              "vendor": 5,
              "fileNamePrefix": [this.cliActId, this.monthYear]//["vcvedio"]
            }
          }
        };

        const reqBodyNew = {
          "uid": this.userId,
          "cname": this.videoRecordingDetailsObj['channel'],
          "clientRequest": {
            "token": newToken,
            "recordingConfig": {
              "maxIdleTime": 30,
              "streamTypes": 2,
              "channelType": 0,
              "subscribeUidGroup": 0
            },
            "snapshotConfig": {
              "captureInterval": 5,
              "fileType": [
                "jpg"
              ]
            },
            "recordingFileConfig": {
              "avFileType": [
                "hls"
              ]
            },
            "storageConfig": {// Astute Azure Storage object
              "accessKey": "atom361dev",//"tzN2CeTjfZ/BTe6kyxCNa35Y57H9HX2nE65w1a7CdJRLjOP6KnRQGAfkObBknytE4z+PBI8QXNHbC9tjb36BNg==",
              "region": 14,
              "bucket": "agoravideo",
              "secretKey": "tzN2CeTjfZ/BTe6kyxCNa35Y57H9HX2nE65w1a7CdJRLjOP6KnRQGAfkObBknytE4z+PBI8QXNHbC9tjb36BNg==",
              "vendor": 5,
              "fileNamePrefix": [this.cliActId, this.monthYear]//["vcvedio"]
            }
          }
        };

        const reqBodyMix = {
          "uid": this.userId,
          "cname": this.videoRecordingDetailsObj['channel'],
          "clientRequest": {
            "token": newToken,
            "recordingConfig": {
              "maxIdleTime": 30,
              "streamTypes": 2,
              "audioProfile": 1,
              "channelType": 0,
              "videoStreamType": 0,
              "transcodingConfig": {
                "width": 360,
                "height": 640,
                "fps": 15,
                "bitrate": 500,
                "mixedVideoLayout": 3,
                "layoutConfig": [{
                  "x_axis": 0.0,
                  "y_axis": 0.0,
                  "width": 1.0,
                  "height": 1.0,
                  "alpha": 1.0,
                  "render_mode": 1
                },
                {
                  "uid": `${this.astuteUserUID}`,
                  "x_axis": 0.75,
                  "y_axis": 0.65,
                  "width": 0.25,
                  "height": 0.25,
                  "alpha": 1.0,
                  "render_mode": 1
                }]
              }
            },
            "recordingFileConfig": {
              "avFileType": [
                "hls", "mp4"
              ]
            },
            "storageConfig": {// Astute Azure Storage object
              "accessKey": this.dataSharingSrvc.apiUrl[this.dataSharingSrvc.environment]['storageConfig']["accessKey"],
              "region": this.dataSharingSrvc.apiUrl[this.dataSharingSrvc.environment]['storageConfig']["region"],
              "bucket": this.dataSharingSrvc.apiUrl[this.dataSharingSrvc.environment]['storageConfig']["bucket"],
              "secretKey": this.dataSharingSrvc.apiUrl[this.dataSharingSrvc.environment]['storageConfig']["secretKey"],
              "vendor": this.dataSharingSrvc.apiUrl[this.dataSharingSrvc.environment]['storageConfig']["vendor"],
              "fileNamePrefix": [this.cliActId, this.monthYear]//["vcvedio"]
            }
          }
        }
        // this.dataSharingSrvc.apiUrl['Production']['storageConfig']
        // this.dataSharingSrvc.apiUrl[this.dataSharingSrvc.environment]['storageConfig']


        /****AWS JSON Object********/

        // const reqBody = {
        //   "uid": "1111001111",//this.videoRecordingDetailsObj['uid'],
        //   "cname": this.videoRecordingDetailsObj['channel'],
        //   "clientRequest": {
        //     "token": newToken,
        //     "recordingConfig": {
        //       "channelType": 0,
        //       "streamTypes": 2,
        //       "subscribeVideoUids": ["#allstream#"],
        //       "subscribeAudioUids": ["#allstream#"],
        //     },
        //     "recordingFileConfig": {
        //       "avFileType": ["hls", "mp4"]
        //     },
        //     "storageConfig": {
        //       "accessKey": "AKIAYMYI63WUL56K6RPK",  //AKIAYMYI63WUL56K6RPK
        //       "region": 14,
        //       "bucket": "viotaldemo",
        //       "secretKey": "fVntZIxLzWZJeWszmbX8PTXEWZk/H07+673ZzEOh", //fVntZIxLzWZJeWszmbX8PTXEWZk/H07+673ZzEOh
        //       "vendor": 1
        //       // "fileNamePrefix": ["agoravideo"]
        //     }
        //   }
        // };

        /************End********/

        const cloudRecordingUrl = `https://api.agora.io/v1/apps/${this.videoRecordingDetailsObj['appId']}/cloud_recording/resourceid/${agoraAquireResId}/mode/mix/start`;


        this.dataSharingSrvc.postAgoraMethod(cloudRecordingUrl, reqBodyMix)
          .subscribe(
            succ => {
              console.log("Recording success : ", succ);
              this.sid = succ['sid'];
            },
            err => {
              console.log("Recording error : ", err);
            }
          )

      }

    })

  }



  invokeAquireAPIandGetResourceId() {
    return new Promise((resolve, reject) => {
      //const Authorization = `Basic ${Buffer.from(`${process.env.RESTkey}:${process.env.RESTsecret}`).toString("base64")}`;
      // const Authorization = `Basic (08d6215e9e97444a8b20a67a467ea0ca:80e69616e58540298edeb123fe0cc683`).toString("base64")}`;
      //  https://api.agora.io/v1/apps/<yourappid>/cloud_recording/acquire

      const agoraUrl = `https://api.agora.io/v1/apps/${this.videoRecordingDetailsObj['appId']}/cloud_recording/acquire`;
      const reqBody = {
        "cname": this.videoRecordingDetailsObj['channel'],
        "uid": this.userId,//"1111001111",// this.videoRecordingDetailsObj['uid'],//4294967296//2700000000
        "clientRequest": {
          "resourceExpiredHour": 24,
          "scene": 0
        }
      };
      this.dataSharingSrvc.postAgoraMethod(agoraUrl, reqBody)
        .subscribe(
          succ => {
            console.log("aquire success : ", succ);
            this.aquiredResourceObj = {};
            this.aquiredResourceObj = succ;
            resolve(succ);
          },
          err => {
            console.log("aquire err : ", err);
            reject(err);
          }
        );
    });
  }


  requestAgoraToStopRecordingsToAllowFilesTbeWrittenOnS3 = () => {
    this.showLoadingModalDialog('Waiting till data save.', "You can close popup once 'Closed Video Call' message appears.")
    const reqBody = {
      "uid": this.userId, //"1111001111",//this.videoRecordingDetailsObj['uid'],
      "cname": this.videoRecordingDetailsObj['channel'],
      "clientRequest": {}
    };
    sendLogDataToServer({ logType: "Start=> request Stop Recordings", reqName: "request Agora To Stop Recordings To AllowFiles Tobe Written On S3", dateTime: new Date().toISOString() });

    const cloudRecordingUrl = `https://api.agora.io/v1/apps/${this.videoRecordingDetailsObj['appId']}/cloud_recording/resourceid/${this.acquiredResourceID}/sid/${this.sid}/mode/mix/stop`
    //const cloudRecordingUrl = `https://api.agora.io/v1/apps/${this.videoRecordingDetailsObj['appId']}/cloud_recording/resourceid/${this.acquiredResourceID}/sid/${this.sid}/mode/mix/stop`;


    this.dataSharingSrvc.postAgoraMethod(cloudRecordingUrl, reqBody).subscribe(result => {
      // console.log('Stoped :', result);
      // if (result['code'] == 0) {
      sendLogDataToServer({ logType: "end=> request Stop Recordings", reqName: "request Agora To Stop Recordings To AllowFiles Tobe Written On S3", dateTime: new Date().toISOString() });
      this.videoRecordingDetailsObj = {};
      if (result['resourceId']) {
        this.videoRecordingDetailsObj = result;
        this.saveDetailsIntoDatabase();

      } else {
        this.showCommonModal("Error", "Error while stoping video recording", "Error");
        this.requestAgoraToStopRecordingsToAllowFilesTbeWrittenOnS3();
      }
      // this.downloadVideoFile();

    }, error => {
      this.showCommonModal("Error", "Error while stoping video recording Kindly contact administrator", "Error Ok");
    });
  }

  muteTheCallAudio() {
    // if(muteAudio())
    this.isMute = muteUnmuteAudio(false);
    // this.isMute = true;
  }
  unmuteTheCallAudio() {
    this.isMute = muteUnmuteAudio(true);
    // this.isMute = false;
  }

  switchDevice() {
    this.isCameraSwitch = !this.isCameraSwitch;
    SwitchDevice(this.isCameraSwitch);
  }
  videoId = 'video';
  snapshots = [];

  captureImage(video, scaleFactor) {
    if (scaleFactor == null) {
      scaleFactor = 1;
    }
    var w = video.videoWidth * scaleFactor;
    var h = video.videoHeight * scaleFactor;
    var canvas = this.renderer.createElement('canvas');// document.createElement('canvas');
    canvas.width = w;
    canvas.height = h;
    var ctx = canvas.getContext('2d');
    ctx.drawImage(video, 0, 0, w, h);
    return canvas;
  }

  shoot() {
    var video = document.getElementById(this.videoId);
    var output = document.getElementById('output');
    var canvas = this.captureImage(video, this.scaleFactor);
    canvas.onclick = function () {
      window.open(this.toDataURL(`image/jpg`));
    };
    this.snapshots.unshift(canvas);
    output.innerHTML = '';
    for (var i = 0; i < 4; i++) {
      output.appendChild(this.snapshots[i]);
    }
  }
  downloadJson() {
    onDownload()
  }
  showToastMsg(isSuccess: boolean, msg: string, timeout?: number) {

    this.toastMsg.isSuccess = isSuccess;
    this.toastMsg.msg = msg;
    this.toastMsg.show = true;
    setTimeout(() => {
      this.toastMsg.show = false;
    }, !timeout ? (isSuccess ? 2000 : 8000) : timeout);
  }
  showLoader(id = 'loader-div') {
    document.getElementById(id).style.display = 'block'
  }
  hideLoader(id = 'loader-div') {
    document.getElementById(id).style.display = 'none'

  }

  showLoadingModalDialog(titleMsg: string, bodyMsg: string, subTitle: string = '') {
    this.loadingTitleModalMsg = titleMsg;
    this.loadingsubTitleModalMsg = subTitle;
    this.loadingBodyModalMsg = bodyMsg;
    this.showLoadingModal = true;
  }
  qualityMode: "balanced" | "motion" | "detail" = 'balanced';
  changeVideoQuality(mode: "balanced" | "motion" | "detail" = "balanced") {
    setOptimizationMode(mode);
  }

  sendCaptureVideImageToServer(arrayIndexId) {
    let body = {
      "autoId": this.dataSharingSrvc["autoId"],
      "caseid": this.caseID,
      "valuetype": "img",
      image: this.capturedImages[arrayIndexId]['image']
    };
    this.dataSharingSrvc.postMethod("saveVCallImage", body)
      .subscribe(succ => {
        if (succ['errorCode'] == 0) {
          this.capturedImages[arrayIndexId]['dbIndex'] = succ['data']['id']
          this.showToastMsg(true, 'Screenshot captured')
        } else {
          this.showToastMsg(false, 'Retry Screenshot');
        }
      }, err => {
        this.capturedImages[arrayIndexId]['retryUploadImage'] = true;
        this.showToastMsg(false, 'Retry Screenshot');
      })
  }
  deleteCaptureVideImageFomServer(arrayIndexId) {
    let body = {
      "autoId": this.dataSharingSrvc["autoId"],
      "caseid": this.caseID,
      dbIndexId: this.capturedImages[arrayIndexId]['dbIndexId']
    };
    console.log('deleteCaptureVideImageFomServer', this.capturedImages);

    if (body['dbIndexId'] == undefined || body['dbIndexId'] <= -1) {
      console.log('no data to delete for db');
      this.capturedImages.splice(arrayIndexId, 1);
      this.capturedImagesForDeletion.splice(arrayIndexId, 1);
      this.showConfirmationModalForDeleteImage = false;
      return
    }
    this.dataSharingSrvc.postMethod("deleteVCallImage", body)
      .subscribe(succ => {
        if (succ['errorCode'] == 0) {
          this.capturedImages.splice(arrayIndexId, 1);
          this.capturedImagesForDeletion.splice(arrayIndexId, 1);
          this.showConfirmationModalForDeleteImage = false;
          this.showToastMsg(true, 'Deleted Successfully.');
        } else {
          this.showToastMsg(false, 'Retry');
        }
      }, err => {
        this.capturedImages[arrayIndexId]['retryUploadImage'] = true;
        this.showToastMsg(false, 'Retry');
      })
  }
  isLngLatSend = false;
  saveVCallDetailsImageAndVideoIntoDatabase = (currentImageIndex: number = -1, sendOnlyLatLong = false, connectionIssueWhileSavingRetry = 0) => {

    this.postDataArr = [];


    if (!this.isLngLatSend) {
      this.postDataArr.push({
        "caseid": this.caseID,
        "valuetype": "lat",
        "value": this.webSocketSrvc['latitude'] || "0.000000",
        "imagebase64": ""
      });

      this.postDataArr.push({
        "caseid": this.caseID,
        "valuetype": "lng",
        "value": this.webSocketSrvc['longitude'] || "0.000000",
        "imagebase64": ""
      });
      this.isLngLatSend = true;
      this.getAddressFromLatLog(this.webSocketSrvc['latitude'] || "0.000000", this.webSocketSrvc['longitude'] || "0.000000");
    }
    if (!sendOnlyLatLong) {
      if (currentImageIndex == -1) {
        this.getVideoFileName();
        // this.showLoader();
        this.postDataArr.push({
          "caseid": this.caseID,
          "valuetype": "videourl",
          "value": this.videoFilePath,//this.getVideoFileName(),
          "imagebase64": ""
        });

        this.postDataArr.push({
          "caseid": this.caseID,
          "valuetype": "callstarttime",
          "value": this.startTime,
          "imagebase64": ""
        });
        this.postDataArr.push({
          "caseid": this.caseID,
          "valuetype": "callendtime",
          "value": this.endTime,
          "imagebase64": ""
        });
        this.postDataArr.push({
          "caseid": this.caseID,
          "valuetype": "callduration",
          "value": this.timeIntervalStr,
          "imagebase64": ""
        });
      } else {
        const element = this.capturedImages[currentImageIndex];

        this.postDataArr.push({
          "caseid": this.caseID,
          "valuetype": "img",
          "value": "",
          "imagebase64": element['image']
        });
      }
      sendLogDataToServer({ logType: "start=>save image Into Database", reqName: "save image Into Database", dateTime: new Date().toISOString() });
    } else {
      sendLogDataToServer({ logType: "start=>save lng lat Into Database", reqName: "save lng lat Into Database", dateTime: new Date().toISOString() });
      // this.isVideoCallStarted = false;

    }


    let body = {
      "caseid": this.caseID,
      "vdetails": this.postDataArr,
      "autoId": this.dataSharingSrvc["autoId"],
      "callStatus": "C"
    };

    this.dataSharingSrvc.postMethod("saveVCallDetailsImageAndVideo", body)
      .subscribe(succ => {
        console.warn("saveVCallDetails success", succ);

        if (succ['errorCode'] == 0) {
          if (!sendOnlyLatLong) {
            if (currentImageIndex == -1) {
              this.confirmCloseWithNoImages = false;
              console.warn("saveVCallDetails success");
              this.isRecordingStarted = false;
              this.isSMSSend = false;
              this.showLoadingModal = false;
              this.showCommonModal("Close Video Call", "Call details are saved. Please close window.", "Ok");
              this.resetProps();
              // leaveChannel();
              // stopLocalStream();
              this.meetingStarted = false;
              const win: any = window;
              sendLogDataToServer({ logType: "end=>save Into Database", reqName: "save Into Database", dateTime: new Date().toISOString() });
            } else {
              this.showToastMsg(true, 'Screenshot captured');
              sendLogDataToServer({ logType: "end=>save image Into Database", reqName: "save image Into Database", dateTime: new Date().toISOString() });
              // debugger;
              const itemElement = succ['retrunObj'][0];
              if (itemElement['valuetype'] == 'img') {
                const resultLastInsId = itemElement['resultLastInsId'][0];
                this.capturedImages[currentImageIndex]['dbIndexId'] = resultLastInsId[0]['id'];
              }

            }
          } else {
            sendLogDataToServer({ logType: "end=>save lng lat Into Database", reqName: "save lng lat Into Database", dateTime: new Date().toISOString() });
          }

        }
        else {
          connectionIssueWhileSavingRetry++;
          if (currentImageIndex == -1) {
            console.error(succ);
            this.isLoader = false;
            this.hideLoader();
            this.showCommonModal("Close Video Call", "Error while saving call details.", "Error");
            this.saveVCallDetailsImageAndVideoIntoDatabase(currentImageIndex, sendOnlyLatLong, connectionIssueWhileSavingRetry);
          } else {
            this.showToastMsg(false, 'Screenshot captured error retack ')
          }
          sendLogDataToServer({ logType: "end=> " + succ['errorDescription'], reqName: "saveVCallDetailsImageAndVideo", dateTime: new Date().toISOString() });

        }

      }, err => {
        connectionIssueWhileSavingRetry++;
        if (currentImageIndex == -1) {
          this.hideLoader();
          this.saveVCallDetailsImageAndVideoIntoDatabase(currentImageIndex, sendOnlyLatLong, connectionIssueWhileSavingRetry);
        } else if (!sendOnlyLatLong) {
          this.showToastMsg(false, 'Screenshot captured error, retry again.')
          this.capturedImages.splice(currentImageIndex, 1);
          this.capturedImagesForDeletion.splice(currentImageIndex, 1);
        }
      });
  }

  sendOnlyLocationWhenItsAvailable() {
    const intervalID = setInterval(() => {
      if (this.webSocketSrvc['latitude'] && this.webSocketSrvc['longitude']) {
        this.saveVCallDetailsImageAndVideoIntoDatabase(-1, true);
        clearInterval(intervalID);
      } else {
        console.log("latitude and longitude not found", this.webSocketSrvc['latitude'], this.webSocketSrvc['longitude']);

      }
    }, 5000);

  }
  getAddressFromLatLog(latitude, longitude) {
    let obj = {
      "latitude": latitude,
      "longitude": longitude
    }

    this.dataSharingSrvc.getMethod("getAddess?criteria=" + JSON.stringify(obj), {}).subscribe(
      (res: any) => {
        const geo = res['data']['res'];
        let formatedAddess = "GOOGLE API has not been able to identify the address."
        // if (((Newtonsoft.Json.Linq.JValue)geo.status).Value.ToString().ToUpper() == "OK") 
        if (geo['status'] == "OK") {
          formatedAddess = geo.results[0]?.formatted_address;
        } else if (geo['status'] == "ZERO_RESULTS") {
          formatedAddess = geo?.plus_code?.compound_code;
        }
        this.address = formatedAddess;
        // geo.results[0].formatted_address
        // const formatedAddess1 = geo.results[1].formatted_address;
        // const formatedAddess2 = geo.results[2].formatted_address;
        // const formatedAddess3 = geo.results[3].formatted_address;
        return formatedAddess;
      },
      err => {
        console.error(err, obj);
      });
  }


}
